var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.59,
    height: 20.346,
    viewBox: "0 0 22.59 20.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36506",
    "data-name": "Group 36506",
    transform: "translate(0.999 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39838",
    "data-name": "Path 39838",
    d: "M12,16.011a1,1,0,0,1-1-1V15a1,1,0,0,1,2,0v.011A1,1,0,0,1,12,16.011Z",
    transform: "translate(-1.693 -1.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39839",
    "data-name": "Path 39839",
    d: "M12,14.086a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v4.086A1,1,0,0,1,12,14.086Z",
    transform: "translate(-1.693 -2.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39840",
    "data-name": "Path 39840",
    d: "M5.165,22.314H5.112a3.289,3.289,0,0,1-2.878-4.522,1,1,0,0,1,.061-.125l8.12-14.01a3.289,3.289,0,0,1,5.745,0l8.12,14.011a1,1,0,0,1,.062.126,3.289,3.289,0,0,1-3.026,4.522H5.29l-.062,0ZM4.066,18.6a1.289,1.289,0,0,0,1.149,1.716h.011l.063,0H21.307a1.289,1.289,0,0,0,1.2-1.715L14.426,4.65l-.01-.017a1.289,1.289,0,0,0-2.255,0l-.01.017Z",
    transform: "translate(-2.993 -2.968)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.c994d0dcd7c096861e4996cfa116a0f3.svg";
export { ForwardRef as ReactComponent };